
import { Component } from '@angular/core';
import { ActivatedRoute, Data, Event, NavigationEnd, Router, UrlSegment } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';

import { Message, MessageType, User } from '../../models';
import { AzureClient, IdentityService, MessageRelayService, AutoUnsubscribe } from '../../services';

@Component({
    selector: 'app-banner',
    template: require('./app-banner.html'),
    styles: [require('./app-banner.css')],
})

@AutoUnsubscribe()
export class AppBanner {
    public me: User;
    public url: string;
    public appTitle: string;
    protected isHome: boolean = false;

    private subscriptions: any[] = [];

    constructor(
        private activatedRoute: ActivatedRoute,
        public router: Router,
        private azure: AzureClient,
        private identity: IdentityService,
        private msgRelaySvc: MessageRelayService,
    ) { }

    ngOnInit() {
        this.subscriptions.push(this.identity.me$.subscribe((me: User) => {
            this.me = me;
        }));

        this.subscriptions.push(this.azure.azureLogin$.subscribe((data: any) => {
            this.identity.loadMe();
        }));

        this.subscriptions.push(this.router.events.pipe(
            filter((event) => event instanceof NavigationEnd),
            map(() => this.activatedRoute),
            map((route) => {
                while (route.firstChild)
                    route = route.firstChild;
                return route;
            }),
            filter((route) => route.outlet === 'primary'),
            mergeMap((route) => route.data)
        ).subscribe((data: Data) => {
            this.url = data['bannerTitle'] || '';
        }));

        this.subscriptions.push(this.router.events.pipe(
            filter((event) => event instanceof NavigationEnd),
            map(() => this.activatedRoute),
            map((route) => {
                while (route.firstChild)
                    route = route.firstChild;
                return route;
            }),
            filter((route) => route.outlet === 'primary'),
            mergeMap((route) => route.url)
        ).subscribe((segments: UrlSegment[]) => {
            if (segments.length > 0 && segments[0].path === 'home')
                this.isHome = true;
            else
                this.isHome = false;
        }));

        this.appTitle = `NuPortal${this.azure.client['applicationUrl'].indexOf('-') >= 0 ? '*' : ''}`;

        this.me = this.identity.me;
    }

    bannerClick() {
        this.msgRelaySvc.send(new Message({ sender: "AppComponent", type: MessageType.Mouse, data: "click" }))
    }
}